import React from "react";
import cns from "classnames";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  centered?: boolean;
  wide?: boolean;
  children?: React.ReactNode;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  wrapper: {
    padding: `${theme.spacing(2)}px 0`,

    "& > div:not(:last-child)": {
      marginBottom: theme.spacing(2)
    }
  },

  centered: {
    marginLeft: "auto",
    marginRight: "auto"
  }
}));

/**
 * Display left label and the field together inside grid items
 */
export function FormWrapper({ centered, children, wide }: Props) {
  const classes = useStyles({});
  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={wide ? 12 : 8}
        md={wide ? 12 : 6}
        lg={wide ? 8 : 6}
        className={cns(classes.wrapper, { [classes.centered]: centered })}
      >
        {children}
      </Grid>
    </Grid>
  );
}

FormWrapper.defaultProps = {
  centered: true
};
